export const scheduleDays = [
  {
    key: "mon",
    label: "周一",
    shows: [
      { time: "19:30", title: "咒术回战", ep: "第 12 话", tag: "战斗" },
      { time: "21:00", title: "排球少年!!", ep: "第 06 话", tag: "运动" },
      { time: "23:00", title: "夏目友人帐", ep: "第 03 话", tag: "治愈" },
    ],
  },
  {
    key: "tue",
    label: "周二",
    shows: [
      { time: "20:00", title: "药屋少女的呢喃", ep: "第 09 话", tag: "悬疑" },
      { time: "22:30", title: "冰菓", ep: "第 05 话", tag: "推理" },
      { time: "23:30", title: "白色相簿2", ep: "第 04 话", tag: "恋爱" },
    ],
  },
  {
    key: "wed",
    label: "周三",
    shows: [
      { time: "19:00", title: "蓝色监狱", ep: "第 15 话", tag: "运动" },
      { time: "21:30", title: "灵能百分百", ep: "第 07 话", tag: "超能力" },
      { time: "23:00", title: "孤独摇滚！", ep: "第 08 话", tag: "音乐" },
    ],
  },
  {
    key: "thu",
    label: "周四",
    shows: [
      { time: "20:30", title: "迷宫饭", ep: "第 11 话", tag: "奇幻" },
      { time: "22:00", title: "强风吹拂", ep: "第 06 话", tag: "运动" },
      { time: "23:30", title: "进击的巨人", ep: "第 10 话", tag: "暗黑" },
    ],
  },
  {
    key: "fri",
    label: "周五",
    shows: [
      { time: "19:30", title: "间谍过家家", ep: "第 14 话", tag: "日常" },
      { time: "21:00", title: "关于我转生变成史莱姆这档事", ep: "第 18 话", tag: "异世界" },
      { time: "23:00", title: "无职转生", ep: "第 09 话", tag: "异世界" },
    ],
  },
  {
    key: "sat",
    label: "周六",
    shows: [
      { time: "18:00", title: "鬼灭之刃 无限城篇", ep: "第 07 话", tag: "战斗" },
      { time: "20:30", title: "我推的孩子", ep: "第 13 话", tag: "青春" },
      { time: "22:00", title: "辉夜大小姐想让我告白", ep: "第 12 话", tag: "恋爱" },
      { time: "23:30", title: "地狱乐", ep: "第 05 话", tag: "暗黑" },
    ],
  },
  {
    key: "sun",
    label: "周日",
    shows: [
      { time: "17:30", title: "葬送的芙莉莲", ep: "第 20 话", tag: "奇幻" },
      { time: "20:00", title: "紫罗兰永恒花园", ep: "第 06 话", tag: "治愈" },
      { time: "22:30", title: "Re:从零开始的异世界生活", ep: "第 16 话", tag: "悬疑" },
    ],
  },
];